module.exports = __webpack_public_path__ + "static/img/icon1.d37721a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpesa/icon1.png
// module id = S/qB
// module chunks = 1